import React, { memo, type PropsWithChildren } from 'react';
import { StyleSheet, View } from 'react-native';

// ─────────────────────────────────────────────────────────────────────────────

export const IngredientListItemContentContainer = memo(
  (props: PropsWithChildren) => {
    const { children } = props;

    return (
      <View style={styles.outerContainer}>
        <View style={styles.innerContainer}>{children}</View>
      </View>
    );
  },
);

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  outerContainer: {
    flexDirection: 'row',
    flex: 1,
  },
  innerContainer: {
    flex: 1,
  },
});
